var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.url)?_c('iocIframe',{attrs:{"src":_vm.url,"frameborder":"0"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }